<template>
    <!-- START OVERLAY -->
    <div class="overlay"
         style="display: none"
         data-pages="search">
        <!-- BEGIN Overlay Content !-->
        <div class="overlay-content has-results m-t-20">
            <overlay-header></overlay-header>
            <overlay-controls @update:filters="updateFilters"></overlay-controls>
            <searching v-show="searching">
            </searching>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <pagination v-if="paginationNeeded"
                            :current-page="pagination_data.current_page - 1"
                            :total-pages="pagination_data.last_page"
                            @click="getPageOnClick">
                        </pagination>
                    </div>
                </div>
            </div>

            <component v-if="!searching"
                       :is="resultsComponentName"
                       :customers="customers"></component>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <pagination v-if="paginationNeeded"
                            :current-page="pagination_data.current_page - 1"
                            :total-pages="pagination_data.last_page"
                            @click="getPageOnClick">
                        </pagination>
                    </div>
                </div>
            </div>

        </div>
        <!-- END Overlay Content !-->
    </div>
    <!-- END OVERLAY -->
</template>

<script type="text/babel">
    import OverlayHeader from "./Header"
    import OverlayControls from "./Controls"
    import OverlayResults from "./Results"
    import NoResults from "./NoResults"
    import Searching from "./Searching"
    import Pagination from 'components/Pagination'

    export default {
      components: {
        OverlayHeader,
        OverlayControls,
        OverlayResults,
        NoResults,
        Searching,
        Pagination,
      },

      data() {
        return {
          getPageOnClick: null,
          debFunc: null,
          searched: '',
          customers: [],
          pagination_data: {
            current_page: 1,
            last_page: 1,
            per_page: 1,
            total: 0,
          },
          searching: false,
          filters: {
            agencies: [],
          },
          querySource: null,
          order: null,
          order_by: 'asc',
          set_order: null,
        }
      },

      created() {
        this.debFunc = _.debounce(this.onSearchSubmit, 750)
        this.getPageOnClick = _.debounce(this.getPage, 200)

        this.set_order = (field, by) => {
          this.order = field
          this.order_by = by
          this.debFunc($("#overlay-search").val())
        }
      },

      mounted() {
        $('[data-pages="search"]').search({
          searchField: "#overlay-search",
          closeButton: ".overlay-close",
          suggestions: "#overlay-suggestions",
          brand: ".brand",
          onSearchSubmit: this.debFunc,
          onKeyEnter: this.debFunc,
        })
      },

      computed: {
        resultsComponentName() {
          return this.customers.length ? "OverlayResults" : "NoResults"
        },

        paginationNeeded () {
           return this.pagination_data.last_page > 1
        },
      },

      methods: {
        getPage(idx) {
            const page = idx + 1

            if (this.searched.length < 3) {
                this.searchCustomers(this.searched, 'strict', page)
            } else {
                this.searchCustomers(this.searched, 'default', page)
            }
        },

        onSearchSubmit(toSearch) {
          console.log("onSearchSubmit enter with: " + toSearch)

          // Variables init
          let customers = null
          let searchCondition = false

          // We first try to identify if the customer is accessing to the ID based search (search starts with the `#` symbol)
          const trimmedInput = _.trim(toSearch)

          if (_.startsWith(trimmedInput, "#")) {
            const searchString = trimmedInput.substring(1)

            // We make sure something searchable has been typed
            if (searchString.length === 0) {
              return
            }

            this.searchCustomers(searchString, 'id')
          } else {
            const searchString = trimmedInput

            // We make sure something searchable has been typed
            if (searchString.length === 0) {
              return
            }

            this.searched = searchString

            if (searchString.length < 3) {
              this.searchCustomers(searchString, 'strict')
            } else {
              this.searchCustomers(searchString, 'default')
            }
          }
        },

        searchCustomers(searchString, searchType, page = 1) {
          if (!['id', 'strict', 'default'].includes(searchType)) {
            return
          }

          let searchFields = null

          // We show the active search (loading) component
          this.searching = true

          // We cancel any active request (when it exists)
          if (!_.isNull(this.querySource)) {
            this.querySource.cancel("filters changed")
          }
          this.querySource = this.axios.CancelToken.source()

          // We proceed to search
          if ('id' === searchType) {
            searchFields = 'sap_busort:=;erp_id:=';
          } else if ('strict' === searchType) {
            searchFields = 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:=';
          }

          this.fetchCustomers(searchString, searchFields, page)
              .then(response => {
                this.customers = !_.isNil(response.data.data) ? response.data.data : []
                this.pagination_data = !_.isNil(response.data) ? response.data : {}
              })

          // We hide the active search (loading) component
          this.searching = false
        },

        updateFilters(newFilters) {
          this.filters = Object.assign({}, this.filters, newFilters)
          this.debFunc($("#overlay-search").val())
        },

        fetchCustomers(searchString, searchFields = null, page = 1) {
          let params = {
            search: searchString,
            with: "contracts.proxies.type;representatives",
            paginate: 1,
            page,
            ...this.filters,
          }

          if (searchFields != null) {
            params.searchFields = searchFields
          }

          if (this.order != null) {
            params.order = this.order
            params.order_by = this.order_by
          }

          return this.axios.get("customers", {
            cancelToken: this.querySource.token,
            params: params,
          })
        },

        fetchContractProxies(contractId) {
          return this.axios.get(`contracts/${contractId}/proxies`)
        },
      },
    }
</script>



// WEBPACK FOOTER //
// client/components/SearchOverlay/SearchOverlay.vue